export function UsersDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.USERS + '/:username')
        .setCustomActions({
            'getAll': {
                method: 'GET',
                isArray: true
            },
            'getOne': {
                method: 'GET',
                params: {username: '@username'}
            },
            'create': {
                method: 'POST',
                notifications: true
            },
            'update': {
                method: 'PUT',
                params: {username: '@username'},
                notifications: true
            }, 'updateInternal': {
                method: 'PUT',
                params: {username: '@username'},
                notifications: true,
                path: '/../api/v1/internal/users/:username'
            },
            'delete': {
                method: 'DELETE',
                params: {username: '@username'},
                notifications: true
            },
            'getProfile': {
                method: 'GET',
                path: XRAY_RESOURCE.USERS + '/profile/:username',
                params: {username: '@username'}
            },
            'updateProfile': {
                method: 'POST',
                path: XRAY_RESOURCE.USERS + '/profile',
                notifications: true
            }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/users_dao.js